"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetEmailTokenResponse", {
    enumerable: true,
    get: function() {
        return GetEmailTokenResponse;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const GetEmailTokenResponse = _zod.z.object({
    tokens: _zod.z.array(_zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectID),
        user_id: _zod.z.instanceof(_bson.ObjectID),
        token: _zod.z.string(),
        email: _zod.z.string()
    }))
});
